export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const CHANGE = 'CHANGE';
export const LOADING = 'LOADING';
export const SETMENUNPOSITION = 'SETMENUNPOSITION';
export const ADDTOCART = 'ADDTOCART';
export const UPDATECART = 'UPDATECART';
export const CATEGORYFETCH = 'CATEGORYFETCH';
export const CATEGORYCHANGE = 'CATEGORYCHANGE';



// WEBPACK FOOTER //
// ./src/actions/ActionType.js